// /pricing: the plans, the estimator, the comparison and the questions
// (handoff design/website/Pricing.dc.html). OD-B2 (HARD, not approved): the
// page is built but noindex, and nothing links to it (siteNav.ts
// PRICING_PUBLISHED) until the owner confirms the figures. Anyone may open it
// by its address; a signed-in chef reading it keeps their session.
import { createFileRoute } from '@tanstack/react-router';
import { PricingPage } from '@/features/site/pricing/PricingPage';

export const Route = createFileRoute('/_site/pricing')({
  component: PricingPage,
});
